var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8C1 6.01088 1.79018 4.10322 3.1967 2.6967C4.60322 1.29018 6.51088 0.5 8.5 0.5C10.4891 0.5 12.3968 1.29018 13.8033 2.6967C15.2098 4.10322 16 6.01088 16 8C16 9.98912 15.2098 11.8968 13.8033 13.3033C12.3968 14.7098 10.4891 15.5 8.5 15.5C6.51088 15.5 4.60322 14.7098 3.1967 13.3033C1.79018 11.8968 1 9.98912 1 8Z",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8,
    r: 6,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCircle);
export default __webpack_public_path__ + "static/media/filled_circle.80640dc2ea68f910dcfe547619d3667f.svg";
export { ForwardRef as ReactComponent };